import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 40px;
  border: none;
  font-family: ${Theme.fontFamily.SECONDARY};
  cursor: pointer;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.primaryBtnTxt};
  background: ${({ theme }) => theme.colors.primary};
  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }
  &:focus {
    fill: ${({ theme }) => theme.colors.primary};
    stroke-width: 1px;
    stroke: ${({ theme }) => theme.colors.primary};
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);
    background: ${({ theme }) => theme.colors.primary};
  }
  &:disabled {
    background: ${Theme.pallete.SECONDARY3};
    color: ${Theme.pallete.QUATERNARY};
    cursor: not-allowed;
  }
  .default-btn-img {
    max-width: 14px;
    max-height: 14px;
    margin-right: 5px;
    filter: ${({ theme }) => theme.filters.primaryIcon};
    @media only screen and (min-width: 1441px) {
      max-width: 18px;
      max-height: 18px;
      margin-right: 6px;
    }
  }

  @media only screen and (min-width: 1441px) {
    height: 45px;
    font-size: 13px;
  }
`
